import type { SVGProps } from "react";

export default function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.02 24.53"
      width={20}
      height={20}
      fill="currentColor"
      {...props}
    >
      <g id="Layer_1-2" data-name="Layer 1-2">
        <path d="M13.15,5.96c.8,0,1.46.66,1.46,1.46s-.66,1.46-1.46,1.46-1.46-.66-1.46-1.46.66-1.46,1.46-1.46ZM8.76,8.87c-.8,0-1.46-.66-1.46-1.46s.66-1.46,1.46-1.46,1.46.66,1.46,1.46-.66,1.46-1.46,1.46ZM8.76,13.24c-.8,0-1.46-.66-1.46-1.46s.66-1.46,1.46-1.46,1.46.66,1.46,1.46-.66,1.46-1.46,1.46ZM8.76,17.61c-.8,0-1.46-.66-1.46-1.46s.66-1.46,1.46-1.46,1.46.66,1.46,1.46-.66,1.46-1.46,1.46ZM4.38,13.24c-.8,0-1.46-.66-1.46-1.46s.66-1.46,1.46-1.46,1.46.66,1.46,1.46-.66,1.46-1.46,1.46ZM4.38,17.61c-.8,0-1.46-.66-1.46-1.46s.66-1.46,1.46-1.46,1.46.66,1.46,1.46-.66,1.46-1.46,1.46ZM20.45,9.47c1.31,0,2.54.31,3.65.83V1.46c0-.8-.66-1.46-1.46-1.46h-2.92c-.8,0-1.46.66-1.46,1.46s-.66,1.46-1.46,1.46-1.46-.66-1.46-1.46-.66-1.46-1.46-1.46h-3.65c-.8,0-1.46.66-1.46,1.46s-.66,1.46-1.46,1.46-1.46-.66-1.46-1.46-.66-1.46-1.46-1.46H1.46C.66,0,0,.66,0,1.46v18.21c0,.8.66,1.46,1.46,1.46h11.07c-.39-.98-.61-2.03-.61-3.15,0-4.7,3.82-8.51,8.53-8.51ZM21.36,18.34c0,.5-.41.91-.91.91h-3.65c-.5,0-.91-.41-.91-.91s.41-.91.91-.91h2.74v-3.46c0-.5.41-.91.91-.91s.91.41.91.91v4.37ZM20.45,11.42c-3.63,0-6.57,2.93-6.57,6.55s2.94,6.56,6.57,6.56,6.57-2.94,6.57-6.56-2.94-6.55-6.57-6.55Z" />
      </g>
    </svg>
  );
}
